const OwnProduction = () =>{
    return(
        <>  
            <section>
                <div className="xl:pb-16 lg:pb-14 md:pb-12 sm:pb-8">
                    <h2 className="uppercase font-medium w-full
                    xl:text-4xl xl:pb-12
                    lg:text-4xl lg:pb-12
                    md:text-3xl md:pb-10
                    sm:text-[28px] sm:pb-4">Собственное производство</h2>
                    <p>Полётный контроллер <span className="font-bold uppercase text-[#304DB6]">СТРИЖ</span>, создан на основе отечественных микроплат. Этот контроллер обеспечивает высокую стабильность полёта, точное позиционирование и эффективное управление дроном.</p>
                </div>
                
                <div className="flex flex-col 
                xl:gap-8
                lg:gap-8 
                md:gap-6
                sm:gap-4">
                    <div className="
                    xl:flex xl:flex-row-reverse 
                    lg:flex lg:flex-row-reverse 
                    md:flex md:flex-row-reverse 
                    sm:flex-col ">
                        <div className="flex flex-col 
                        xl:items-center xl:justify-center xl:w-1/2 
                        lg:items-center lg:justify-center lg:w-1/2 
                        md:items-center md:justify-center md:w-1/2 
                        sm:w-full">
                            <div className="
                            xl:pl-[100px] xl:py-[105px] 
                            lg:pl-[100px] lg:py-[105px] 
                            md:pl-[100px] md:py-[105px] 
                            sm:pl-0 sm:py-0">
                                <h3 className='font-bold text-3xl
                                xl:pb-6
                                lg:pb-6  
                                md:pb-4 
                                sm:pb-2'>Тестирование</h3>
                                <p className="sm:pb-2">Полётный контроллер <span className="font-bold uppercase text-[#304DB6]">СТРИЖ</span>, создан на основе отечественных микроплат</p>
                            </div>
                        </div> 
                        <div className=" bg-slate-700 
                        xl:w-1/2 
                        lg:w-1/2 
                        md:w-1/2 
                        sm:w-full sm:min-h-[300px]">
                            <iframe></iframe>
                        </div>
                    </div>

                    <div className="xl:flex lg:flex md:flex">
                        <div className="flex flex-col 
                        xl:items-center xl:justify-center xl:w-1/2 
                        lg:items-center lg:justify-center lg:w-1/2
                        md:items-center md:justify-center md:w-1/2 
                        sm:w-full">
                            <div className="
                            xl:pl-[100px] xl:py-[105px] 
                            lg:pl-[100px] lg:py-[105px] 
                            md:pr-[100px] md:py-[105px] 
                            sm:pl-0 sm:py-0">
                                <h3 className='font-bold text-3xl
                                xl:pb-6
                                lg:pb-6  
                                md:pb-4 
                                sm:pb-2'>Калибровка</h3>
                                <p className="sm:pb-2">Полётный контроллер <span className="font-bold uppercase text-[#304DB6]">СТРИЖ</span>, создан на основе отечественных микроплат. </p>
                            </div>
                        </div> 
                        <div className=" bg-slate-700 xl:w-1/2 
                        lg:w-1/2 
                        md:w-1/2 
                        sm:w-full sm:min-h-[300px]">
                            <iframe></iframe>
                        </div>
                    </div>

                    <div className="
                    xl:flex xl:flex-row-reverse 
                    lg:flex lg:flex-row-reverse 
                    md:flex md:flex-row-reverse 
                    sm:flex-col ">
                        <div className="flex flex-col 
                        xl:items-center xl:justify-center xl:w-1/2 
                        lg:items-center lg:justify-center lg:w-1/2 
                        md:items-center md:justify-center md:w-1/2 
                        sm:w-full">
                            <div className="
                            xl:pl-[100px] xl:py-[105px] 
                            lg:pl-[100px] lg:py-[105px] 
                            md:pl-[100px] md:py-[105px] 
                            sm:pl-0 sm:py-0">
                                <h3 className='font-bold text-3xl
                                xl:pb-6
                                lg:pb-6  
                                md:pb-4 
                                sm:pb-2'>Испытания</h3>
                                <p className="sm:pb-2">Полётный контроллер <span className="font-bold uppercase text-[#304DB6]">СТРИЖ</span>, создан на основе отечественных микроплат</p>
                            </div>
                        </div> 
                        <div className=" bg-slate-700 
                        xl:w-1/2 
                        lg:w-1/2 
                        md:w-1/2 
                        sm:w-full sm:min-h-[300px]">
                            <iframe></iframe>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default OwnProduction;